import { Container, Loader, Text } from "@mantine/core";
import { useNavigate, useParams } from "react-router-dom";
import {
  useGetCampaign,
  usePatchCampaign,
  useSendCampaign,
  useScheduleCampaign,
} from "../../api/campaigns";
import CampaignForm from "./CampaignForm";
import { useContext } from "react";
import { AuthContext } from "../../services/context";
import { getCurrentWorkspace } from "../../services/userConfig";
import { useGetEvent } from "../../api/event";

const EditCampaign = () => {
  const { id } = useParams();
  const { user } = useContext(AuthContext);
  const { eventId } = getCurrentWorkspace(user);

  const navigate = useNavigate();

  const { data, isPending, isSuccess, isError, error } = useGetCampaign({
    id,
    eventId,
  });

  const { mutate, isPending: patchPending } = usePatchCampaign({ id, eventId });
  const { mutate: sendCampaign } = useSendCampaign({ eventId });
  const { mutate: scheduleCampaign } = useScheduleCampaign({ eventId });
  const { data: event } = useGetEvent(data?.eventId);

  const handleSubmit = (submitData) => {
    mutate(submitData, { onSuccess: () => navigate("/app/campaigns") });
  };

  const handleSendNow = (dirtyData) => {
    const doSend = () =>
      sendCampaign({ id }, { onSuccess: () => navigate("/app/campaigns") });

    if (Object.keys(dirtyData).length > 0) {
      mutate(dirtyData, { onSuccess: doSend });
    } else {
      doSend();
    }
  };

  const handleSchedule = (dirtyData, scheduledAt) => {
    const doSchedule = () =>
      scheduleCampaign(
        { id, scheduledAt },
        { onSuccess: () => navigate("/app/campaigns") }
      );

    if (Object.keys(dirtyData).length > 0) {
      mutate(dirtyData, { onSuccess: doSchedule });
    } else {
      doSchedule();
    }
  };

  return (
    <Container size="xl">
      {isPending && <Loader />}
      {isError && <Text c="red">{error.message}</Text>}
      {isSuccess && (
        <CampaignForm
          initialData={data}
          onSubmit={handleSubmit}
          isSubmitting={patchPending}
          mode="edit"
          event={event}
          onSendNow={handleSendNow}
          onSchedule={handleSchedule}
        />
      )}
    </Container>
  );
};

export default EditCampaign;
